import {unwrapResult} from '@reduxjs/toolkit';
import {useCallback} from 'react';

import {
    clearAllAction,
    clearErrorsAction,
    getAllCustomers,
    getCustomerById,
    updateAction,
    setSelectedCustomerProfileId,
    setSelectedIdCustomer,
} from './actions';
import {
    activeCompanySelector,
    activeCustomerSelector,
    activeProfileSelector,
    customersCountSelector,
    customersSelector,
    errorMessageSelector,
    isFetchingSelector,
    profilesSelector,
    selectedIdSelector,
} from './selectors';
import {useAppDispatch, useAppSelector} from "../hooks";
import {AppDispatch} from "../store";
import {CustomerUpdateData} from "../../services";

export const useCustomerStore = () => {
    const dispatch: AppDispatch = useAppDispatch();
    const isFetching = useAppSelector(isFetchingSelector);
    const errorMessage = useAppSelector(errorMessageSelector);
    const customersCount = useAppSelector(customersCountSelector);
    const customers = useAppSelector(customersSelector);
    const activeCustomer = useAppSelector(activeCustomerSelector);
    const activeProfile = useAppSelector(activeProfileSelector);
    const profiles = useAppSelector(profilesSelector);
    const activeCompany = useAppSelector(activeCompanySelector);
    const selectedId = useAppSelector(selectedIdSelector);

    // const bookingsByProfilePackageId = useCallback(
    //     (profilePackageId: string ) => {
    //         useAppSelector((state) => bookingsByProfilePackageIdSelector(state, profilePackageId))
    //         return bookingsByProfilePackageIdSelector;
    //     },
    //     []
    // );

    const getAll = useCallback(
        () => {
            return dispatch(getAllCustomers()).then(unwrapResult);
        },
        [dispatch]
    );

    const getById = useCallback(
        (id: number) => {
            return dispatch(getCustomerById(id)).then(unwrapResult);
        },
        [dispatch]
    );

    const update = useCallback(
        (arg: { customerId: number, data: CustomerUpdateData }) => {
            return dispatch(updateAction(arg)).then(unwrapResult);
        },
        [dispatch]
    );

    const clearAll = useCallback(
        () => {
            return dispatch(clearAllAction()).then(unwrapResult);
        },
        [dispatch]
    );

    const clearErrors = useCallback(
        () => {
            return dispatch(clearErrorsAction()).then(unwrapResult);
        },
        [dispatch]
    );

    const setSelectedId = useCallback(
        (arg: { id: number }) => {
            return dispatch(setSelectedIdCustomer(arg)).then(unwrapResult);
        },
        [dispatch]
    );

    const setSelectedProfileId = useCallback(
        (arg: { profileId: number }) => {
            return dispatch(setSelectedCustomerProfileId(arg)).then(unwrapResult);
        },
        [dispatch]
    );

    return {
        isFetching,
        errorMessage,
        customersCount,
        customers,
        activeCompany,
        activeCustomer,
        activeProfile,
        profiles,
        getAll,
        getById,
        update,
        clearAll,
        clearErrors,
        setSelectedId,
        setSelectedProfileId,
        selectedId,
    } as const;
};
